import React from 'react'
import { arrayOf, string, number, oneOfType } from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { Flex, Text } from 'rebass'
import { Blockquote, media } from '../../utils/style'
import typography from '../../utils/typography'
import BlockquoteOpen from '../../vectors/BlockquoteOpen'
import BlockquoteClose from '../../vectors/BlockquoteClose'

const Quote = styled(Flex)`
  align-items: center;
  justify-content: center;
  ${media.MediumScreenUp`
    align-items: left;
    justify-content: left;
  `};
  position: relative;
  border-top: 1px ${(props) => props.theme.colors.blue} solid;
  border-bottom: 1px ${(props) => props.theme.colors.blue} solid;
`

const QuoteText = styled(Blockquote)`
  position: relative;
  font-weight: 600;
  line-height: 1.5;
  color: ${(props) => props.theme.colors.grey_light};
`

const QuoteOpener = styled(BlockquoteOpen)`
  position: absolute;
  top: 2px;
  left: 0;
  transform: scale(0.7);
  ${media.MediumScreenUp`
    transform: scale(1, 1);
  `};
`

const QuoteCloser = styled(BlockquoteClose)`
  position: absolute;
  bottom: 2px;
  right: 10px;
  transform: scale(0.7);
  ${media.MediumScreenUp`
    position: relative;
    right: -20px;
    bottom: -13px;
    transform: scale(1, 1);
  `};
`
const QuoteSource = styled(Text)`
  color: ${(props) => props.theme.colors.blue};
  font-weight: ${(props) => props.theme.weights[1]};
`

class ContentQuoteBlock extends React.PureComponent {
  render() {
    return (
      <Quote
        wrap
        as="blockquote"
        mb={this.props.mb}
        mt={this.props.mt}
        mx={0}
        py={40}
      >
        <QuoteText fontSize={[3, 4]} pl={[35, 50]} pr={[35, 50]}>
          <QuoteOpener />
          {this.props.quote}
          <QuoteCloser />
        </QuoteText>
        <QuoteSource caps pl={[35, 50]} f={2} mt={3} mb={-2}>
          {this.props.quotee && this.props.quotee}
          {this.props.source &&
            this.props.source.map((src) => {
              return ` | ${src}`
            })}
        </QuoteSource>
      </Quote>
    )
  }
}

ContentQuoteBlock.defaultProps = {
  mt: [typography.rhythm(1.5), typography.rhythm(2)],
  mb: [typography.rhythm(1.5), typography.rhythm(2)]
}
ContentQuoteBlock.propTypes = {
  quote: string,
  quotee: string,
  mt: oneOfType([number, string, arrayOf(oneOfType([number, string]))]),
  mb: oneOfType([number, string, arrayOf(oneOfType([number, string]))]),
  source: arrayOf(string)
}

export default withTheme(ContentQuoteBlock)
